import { LoadingOverlay } from "../../../components/Loading";
import { NotFound } from "../../../components/NotFound";
import { useFetchRespostaCanalDireto } from "../../../services/atendimentos/useAtendimentos";
import { useTicketStore } from "../../../store/ticket";
import { ModalDirectChannel } from "./ModalDirectChannel";


type ModalDirectChannelContainerProps = {
    isOpen: boolean;
    onClose: () => void;

}

export const ModalDirectChannelContainer = ({ isOpen, onClose }: ModalDirectChannelContainerProps) => {

    const { ticket } = useTicketStore();

    const { data, isLoading, isError, error, refetch } = useFetchRespostaCanalDireto(
        ticket!.ticket,
        {
            enabled: !!ticket,
            staleTime: Infinity,
        }
    );

    return (
        <>
            {isError && (
                <NotFound
                    error={error}
                    defaultMessage={'Erro ao carregar a resposta do canal direto.'}
                    retry={refetch}
                />
            )}

            {isLoading && <LoadingOverlay />}


            {data && ticket && <ModalDirectChannel
                isOpen={isOpen}
                respostaCanalDireto={data}
                onClose={onClose}
                ticket={ticket}
            />}
        </>
    );
}